import WRAP from 'WRAP-JS'
import { configFirLayer } from "./config/ConfigFir";
import { MAP_ID_FIR } from "../../../store/MapContentsState";

class FIR {
  static NAME = MAP_ID_FIR
  dh;
  layer;
  visible;
  constructor() {
    this.layer = new WRAP.Geo.Layer(FIR.NAME);
    this.layer.setVisible(false);
  }

  initData() {
    return new Promise(resolve => {
      this.dh = WRAP.DH.addObject("FIR"); //pri/conf/data/FIR.json
      this.dh.inspect(() => {
        resolve();
      })
    });
  }

  async drawLayer(visible) {
    this.visible = visible
    if (!this.dh) {
      await this.initData();
      this.layer.configure(this.dh, configFirLayer);
    }
    this.setVisible(this.visible);
  }
  getLayer() {
    return this.layer;
  }
  setVisible(visible) {
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  tooltip(layer, reference) {
    if (!reference || !reference.geo || !reference.geo.properties) return;

    return `${reference.geo.properties.icao}<hr/>${reference.geo.properties.name}`;

  }
}

export default FIR;